import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-fill text-xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">黄游下载</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              正版成人游戏资源安全获取平台。提供安全、快速、正版黄游下载服务，精选高质量游戏资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/category/rpg" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">游戏分类</Link>
              <Link to="/article/best-adult-games-2025-top10" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">文章资讯</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/rpg" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">角色扮演</Link>
              <Link to="/category/visual-novel" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">视觉小说</Link>
              <Link to="/category/simulation" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">模拟经营</Link>
              <Link to="/category/mobile" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">手机游戏</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-600 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-sm"></i></span>
                <span>contact@huangyou-download.com</span>
              </p>
              <p className="text-sm text-foreground-600 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shield-check-line text-sm"></i></span>
                <span>安全认证平台</span>
              </p>
              <p className="text-sm text-foreground-600 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-download-cloud-line text-sm"></i></span>
                <span>高速下载节点</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2025 黄游下载 huangyou-download.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}